/**
 * QueryProvider.jsx
 *
 * Wraps the application with React Query's QueryClientProvider.
 * ReactQueryDevtools is rendered only in development builds.
 *
 * Default QueryClient config:
 *   - staleTime  : 30 000 ms  (30 s)
 *   - retry      : 1
 *   - gcTime     : 5 min (library default)
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
      )}
    </QueryClientProvider>
  );
}

export { queryClient };
